import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import {} from 'v3/data/store/contracting/actions';

import { TableBody, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import TableMui from '@mui/material/Table';
import { PAGE_INITIAL_VALUE, ROWS_PER_PAGE_OPTION } from 'common/constants';
import { formatCurrency } from 'common/constants/currency';
import { formatCPF } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { CancellationStateMapping } from 'v3/data/store/cancellationNavigation/mapping';
import { setFilterCurrentPage, setFilterRowsPerPage } from 'v3/data/store/onlineContracting/actions';
import { OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';
import { OnlineContractingStateMapping } from 'v3/data/store/onlineContracting/mapping';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { RoutesEnum } from 'v3/routes/enum';
import { OnlineContractingMobileTable } from 'v3/shared/components/MobileTable/OnlineContractingMobileTable';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';
import {
  OnlineTableCell,
  OnlineTableCellGroup,
  PaperStyled,
  StatusContainer,
  StatusTableCellGroup,
  TablePaginationStyles,
  TableRowStyled,
} from 'v3/shared/components/Table/styles';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { TitleMedium } from 'v3/shared/typography/TitleMedium';
import { theme } from 'v3/styles/global-styles';

export const OnlineContractingTable = () => {
  const navigate = useNavigate();
  const { filter } = useStoreSelector((store) => store.onlineContracting);
  const { rowsPerPage, page } = filter;
  const { items, count } = useStoreSelector((store) => store.onlineContracting.list);
  const { isDesktop } = useBreakpoints();

  const handleNavigation = (contractingKey: string) => {
    navigate(`${RoutesEnum.ContractingInApp}/${contractingKey}`);
  };

  return (
    <Fragment>
      {items.isEmpty ? (
        <NoItemsFound />
      ) : isDesktop ? (
        <PaperStyled>
          <TableContainer sx={{ maxHeight: 450 }}>
            <TableMui stickyHeader aria-label="sticky tables">
              <TableHead>
                <TableRow>
                  <OnlineTableCell>
                    <TitleMedium>ID de Pagamento</TitleMedium>
                  </OnlineTableCell>
                  <OnlineTableCell>
                    <TitleMedium>Cliente</TitleMedium>
                  </OnlineTableCell>
                  <OnlineTableCell>
                    <TitleMedium>Valor financiado</TitleMedium>
                  </OnlineTableCell>
                  <OnlineTableCell>
                    <TitleMedium>Canal</TitleMedium>
                  </OnlineTableCell>
                  <OnlineTableCell>
                    <TitleMedium>Status cancelamento</TitleMedium>
                  </OnlineTableCell>
                  <OnlineTableCell>
                    <TitleMedium>Status financiamento</TitleMedium>
                  </OnlineTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => {
                  const cancellationStatusTitle =
                    CancellationStateMapping[item?.cancellationStatus as CancellationNavigationEnum]?.title ?? '';

                  const contractingStatusTitle =
                    OnlineContractingStateMapping[item.status as OnlineContractingStateEnum]?.title ||
                    'Status desconhecido';
                  return (
                    <TableRowStyled onClick={() => handleNavigation(item.contractingKey)}>
                      <OnlineTableCellGroup>
                        <SubtitleMedium className="empty-line">
                          {item.creditSimulation.vtexPaymentId ? item.creditSimulation.vtexPaymentId : ''}
                        </SubtitleMedium>
                      </OnlineTableCellGroup>
                      <OnlineTableCellGroup>
                        <SubtitleMedium>{item.person.fullName}</SubtitleMedium>
                        <SubtitleMedium color={theme.palette.secondary.main}>
                          {formatCPF(item.person.cpf)}
                        </SubtitleMedium>
                      </OnlineTableCellGroup>
                      <OnlineTableCellGroup>
                        <SubtitleMedium className="empty-line">
                          {item.creditSimulation.financing?.requestedAmount
                            ? formatCurrency(item.creditSimulation.financing.requestedAmount)
                            : ''}
                        </SubtitleMedium>
                      </OnlineTableCellGroup>
                      <OnlineTableCellGroup>
                        <SubtitleMedium>DimoFinancing</SubtitleMedium>
                      </OnlineTableCellGroup>
                      <StatusTableCellGroup>
                        <StatusContainer>
                          <SubtitleMedium className="empty-line">{cancellationStatusTitle}</SubtitleMedium>
                        </StatusContainer>
                      </StatusTableCellGroup>
                      <StatusTableCellGroup>
                        <StatusContainer>
                          <SubtitleMedium>{contractingStatusTitle}</SubtitleMedium>
                        </StatusContainer>
                      </StatusTableCellGroup>
                    </TableRowStyled>
                  );
                })}
              </TableBody>
            </TableMui>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTION}
            component="div"
            sx={TablePaginationStyles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, value) => {
              setFilterCurrentPage(value);
            }}
            onRowsPerPageChange={(event) => {
              setFilterCurrentPage(PAGE_INITIAL_VALUE);
              setFilterRowsPerPage(Number(event.target.value));
            }}
          />
        </PaperStyled>
      ) : (
        <OnlineContractingMobileTable contractingList={items} />
      )}
    </Fragment>
  );
};
